<div class="columns">
  <p class="columns__label">Columns</p>
  <div class="columns__list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (column of columnArray.controls; track column; let index = $index; let count = $count) {
      <div
        class="columns__list--column"
        cdkDrag
        cdkDragBoundary=".columns__list"
        [cdkDragDisabled]="count === 1"
        cdkDragPreviewContainer="parent">
        <app-column-item [columnGroup]="column" [type]="type" (columnDeleted)="deleteColumn(index)"></app-column-item>
        <div class="columns__list--placeholder" *cdkDragPlaceholder></div>
      </div>
    } @empty {
      <div class="columns__list--empty">No columns added yet. At least one column must be selected.</div>
    }
  </div>
  <app-column-picker
    class="columns__add"
    [treeNodes]="treeNodes"
    [required]="true"
    [openedBy]="'button'"
    [type]="type"
    (selectedColumnKey)="onColumnSelected($event)"></app-column-picker>
</div>
